import { render, staticRenderFns } from "./chance-collect.vue?vue&type=template&id=a0869afe&scoped=true"
import script from "./chance-collect.vue?vue&type=script&lang=js"
export * from "./chance-collect.vue?vue&type=script&lang=js"
import style0 from "./chance-collect.vue?vue&type=style&index=0&id=a0869afe&prod&lang=scss"
import style1 from "./chance-collect.vue?vue&type=style&index=1&id=a0869afe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0.1_webpack@4.47.0__ejs@2._efqjtiugzhgbjdza5v3l2szjuq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0869afe",
  null
  
)

export default component.exports